// src/contexts/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { get as apiGet } from '../services/api'; // Убедись, что путь правильный

const AuthContext = createContext();

export const SUPPORTED_LANGUAGES = ['en', 'ru'];
export const DEFAULT_LOCALE = 'ru'; // Язык по умолчанию

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isUserLoaded, setUserLoaded] = useState(false);

    const getUser = async () => {
        try {
            const response = await apiGet('user'); // Используем импортированную функцию
            if (response.success && response.data) {
                const userData = {
                    ...response.data,
                    lang: SUPPORTED_LANGUAGES.includes(response.data.lang) ? response.data.lang : DEFAULT_LOCALE
                };
                setUser(userData);
            } else {
                // Если пользователь не найден, можно установить дефолтного пользователя или null
                // и использовать DEFAULT_LOCALE
                setUser({ lang: DEFAULT_LOCALE }); // Пример: гость с дефолтным языком
            }
        } catch (error) {
            console.error('AuthContext: Failed to fetch user:', error);
            setUser({ lang: DEFAULT_LOCALE }); // При ошибке тоже дефолтный
        } finally {
            setUserLoaded(true);
        }
    };

    useEffect(() => {
        getUser();
    }, []);

    return (
        <AuthContext.Provider value={{ user, isUserLoaded, refreshUser: getUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(AuthContext);
};
